/** Short "ting" for incoming chat (Web Audio; no asset file). */
export function playMessageNotificationSound() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const now = ctx.currentTime;

    const ping = (freq, start, dur, vol) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = 'sine';
      o.frequency.value = freq;
      o.connect(g);
      g.connect(ctx.destination);
      g.gain.setValueAtTime(vol, start);
      g.gain.exponentialRampToValueAtTime(0.001, start + dur);
      o.start(start);
      o.stop(start + dur + 0.02);
    };

    ping(523.25, now, 0.12, 0.07);
    ping(784, now + 0.06, 0.14, 0.055);

    ctx.resume?.().catch(() => {});
    setTimeout(() => {
      try {
        ctx.close();
      } catch (_) {
        /* ignore */
      }
    }, 400);
  } catch (_) {
    /* ignore */
  }
}
